export default __webpack_public_path__ + "static/bottom-3f0714748fda440628a19c41893e8510.gif";